import $ from "jquery";
import {$doc} from "./_globals.js";

function hide(a) {
  const $a = $(a);

  $($a.attr("href")).addClass("d-none");

  $a
    .removeClass("active")
    .trigger("hide.void.tabs");
}

function show(a) {
  const $a = $(a);

  $($a.attr("href")).removeClass("d-none");

  $a
    .addClass("active")
    .trigger("show.void.tabs");
}

$doc.on("click", ".js-tabs a[href^='#']", function($evt) {
  const $a = $(this).closest("a");

  $a
    .closest(".js-tabs")
    .find("a[href^='#']")
    .not($a)
    .each((i, el) => hide(el));

  show($a);

  $evt.preventDefault()
});
